import {MS_IN_DAY} from 'shared/const';

export function daysBetween(to: UnixTimeStamp, from: UnixTimeStamp): number {
  return (to - from) / MS_IN_DAY;
}
